import * as signalR from "@microsoft/signalr";
import { useEffect, useRef } from "react";

const useHubConnection = (
    url: string,
    connections: (hubConnection: signalR.HubConnection) => void,
    onStart: () => Promise<void> | void = () => {}
) => {
    const connected = useRef(false);
    const hubConnectionRef = useRef<signalR.HubConnection | null>(null);

    useEffect(() => {
        const hubConnection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)  // ?? Information ????
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: retryContext => {
                    // ????????0??2??10??30????
                    if (retryContext.elapsedMilliseconds < 60000) {
                        return Math.min(1000 * Math.pow(2, retryContext.previousRetryCount), 30000);
                    } else {
                        // ??1???????
                        return null;
                    }
                }
            })
            .withUrl(url)
            .build();

        hubConnectionRef.current = hubConnection;

        connections(hubConnection);

        // ????????
        hubConnection.onreconnecting(error => {
            console.warn(`SignalR reconnecting due to error: ${error}`);
            connected.current = false;
        });

        hubConnection.onreconnected(connectionId => {
            console.log(`SignalR reconnected with connectionId: ${connectionId}`);
            connected.current = true;
        });

        hubConnection.onclose(error => {
            console.error(`SignalR connection closed: ${error}`);
            connected.current = false;
        });

        // ????
        hubConnection.start()
            .then(() => {
                connected.current = true;
                console.log(`SignalR connected successfully to ${url}`);
                onStart();
            })
            .catch(error => {
                console.error(`SignalR connection failed: ${error}`);
                connected.current = false;
            });

        return () => {
            if (hubConnectionRef.current && connected.current) {
                hubConnectionRef.current.stop()
                    .then(() => {
                        console.log("SignalR connection stopped");
                    })
                    .catch(error => {
                        console.error(`Error stopping SignalR: ${error}`);
                    });
                connected.current = false;
            }
        };
    }, [url]);

    return hubConnectionRef;
};

export default useHubConnection;
